import React from "react";
import img from "../../assets/images/worldheritage/Rajgad.jpg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Overview = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const content = {
    English: {
      title: "ABOUT US",
      breadcrumb: {
        home: 'HOME',
        page: 'ABOUT US'
      },
      paragraph: `The subject of ‘Archaeology’ is included in the concurrent list of the Constitution of 
      India. It comes under the jurisdiction of both the
       Centre and the State administration. With the formation of the independent State 
       of Maharashtra; the Department of Archives and Historical Monuments was established for the first
        time in the year 1960. In the year 1977; for administrative convenience, two separate directorates viz., the Directorate of Archaeology and Museums, and the Directorate of Archives were created.`,
      paragraph1: `The Directorate of Archaeology and Museums functions under the Department of 
      Cultural Affairs, Government of Maharashtra and is further divided into two branches- Archaeology and 
      Museums. The Directorate operates through its sub-offices at Ratnagiri, Nashik, Pune, Chhatrapati Sambhaji Nagar, Nanded and Nagpur for administrative purposes.`,
      paragraph2: `Discovery of historical monuments, archaeological 
        places and artefacts, studying and documenting them, and declaring them as 
         ‘State Protected Monuments’ so as to offer them legal protection are some of the main functions
       of the Directorate. It thus plays a vital role in the protection, conservation and preservation of
        our heritage. The Directorate also undertakes excavations at archaeological sites so as to bring to 
        the light the glorious past of historical and archaeological places. The Directorate conducts explorations
         programs to explore and document the archaeo-historical places and artefacts. It also undertakes excavations at places explored that are found to be quite rich with archaeo-historical markers. Conservation and preservation of State Protected Monuments, their regular maintenance along with carrying out explorations, studying archaeological artefacts, carrying out excavations and preparing detailed reports are some of the chief objectives of the Directorate. Numerous forts, caves, temples, tombs, mosques, gardens, palaces, gateways, lakes, step-wells, and 
      inscriptions are protected by the Directorate.`,
      paragraph3: `The museums undertake a very important job of preserving and showcasing the heritage of 
      ancient India to the next generation. The Directorate has 13 museums under its jurisdiction that are home
       to artefacts unearthed during excavations and/or those found during explorations, important historical 
       objects, weapons and weaves, clothes and dresses, sculptures and art objects, artworks, inscriptions, 
       structural members of the ancient- mediaeval period, paintings of revered artists etc. The main aim and
        objective of these museums
       is to not only display them for delight but also as educative devices.`,
      paragraph4: `The Directorate under the Department of Cultural Affairs, Government of Maharashtra,
       is in the process of establishing a state-of-the-art State Museum of Maharashtra. This premier institution
        will serve as a cultural repository, showcasing the rich and diverse heritage of Maharashtra — from its
         prehistoric roots to the developments of the modern era. The museum aims to offer an immersive and
          educational experience, celebrating the state’s glorious past through carefully curated exhibits, cutting-edge technology, and interactive displays. The Directorate also actively publishes books to introduce the public to our nations’ glorious past and heritage. These publications include annual report titled ‘Maharashtra Purattatva’, Project reports on monument’s, also reports on repairs, conservation and preservation. The Directorate has also published book series like the ‘Historical places’ series titled ‘Aitihasik Sthaldarshan Mala’ and excavation reports in independent book format among many of its 
      other publications such catalogues of museum collections and exhibitions.`,

      heading3: `Schemes`,
      heading4: `Awards`,
      schemesText: "Forts and Monuments being a living testimony to our glorious heritage need to be conserved and preserved. Forts in Maharashtra are evidences of the brilliance of Chhatrapati Shivaji Maharaj as a King and an administrator.",
      awardstext: "Padmashri Sadashiv Gorakshakar’s contribution to heritage preservation and museum movement is invaluable.",

    },
    मराठी: {
      title: "परिचय",
      breadcrumb: {
        home: 'मुख्यपृष्ठ',
        page: 'परिचय'
      },
      paragraph: `‘पुरातत्त्व’ हा भारताच्या संविधानातील समवर्ती सूचीत समाविष्ट असलेला विषय आहे. केंद्र आणि राज्य प्रशासन अशा दोघांच्याही अधिकार कक्षेत तो येतो. संयुक्त महाराष्ट्र राज्याच्या स्थापनेनंतर, सन १९६० मध्ये प्रथमच पुराभिलेख आणि ऐतिहासिक स्मारके विभागाची स्थापना करण्यात आली. सन १९७७ मध्ये प्रशासकीय सोयीसाठी दोन स्वतंत्र संचालनालये; म्हणजेच, पुरातत्त्व व  वस्तुसंग्रहालये संचालनालय आणि पुराभिलेख संचालनालयाची निर्मिती करण्यात आली. पुरातत्त्व  व वस्तुसंग्रहालये संचालनालय हे महाराष्ट्र शासनाच्या सांस्कृतिक कार्य विभागाच्या अंतर्गत, पुरातत्त्व आणि वस्तुसंग्रहालये अशा दोन शाखांच्या माध्यमातून काम करते. संचालनालयाचे प्रशासकीय  कामकाज रत्नागिरी, नाशिक, पुणे, छत्रपती संभाजीनगर , नांदेड आणि नागपूर या सहा उपविभागांतून चालते.`,
      paragraph1: `पुरातन व ऐतिहासिक स्मारके, स्थळे आणि कलाकृतींचा शोध, अभ्यास आणि दस्तावेजीकरण करणे, तसेच त्यांना कायदेशीर संरक्षण देण्यासाठी 'राज्य संरक्षित स्मारके' म्हणून मान्यता देणे इत्यादी  संचालनालयाची प्रमुख कामे आहेत. आपल्या वारशाचे जतन, संवर्धन आणि संरक्षण यात ते महत्वाची भूमिका बजावते. पुराऐतिहासिक स्थळांचा उज्ज्वल इतिहास प्रकाशात आणण्यासाठी संचालनालयामार्फत पुरातत्त्व स्थळांवर उत्खनन इत्यादी  कामे केली जातात.`,
      paragraph2: `पुराऐतिहासिक स्थळे आणि कलाकृतींचा शोध घेणे, त्यांचे दस्तावेजीकरण करणे, यासाठी शोध-अन्वेषण कार्यक्रमांचे आयोजन संचालनालयामार्फत केले जाते. यातून सापडलेल्या ऐतिहासिकदृष्ट्या समृद्ध खाणाखुणांच्या आधारे त्या स्थळांवर उत्खनन केले जाते. राज्य संरक्षित स्मारकांचे संवर्धन आणि संरक्षण, त्यांची दैनंदिन देखभाल, खेरीज शोध-अन्वेषण, पुरातात्त्विक  कलाकृतींचा अभ्यास आणि विस्तृत अहवाल बनवणे, ही संचालनालयाची प्रमुख उद्दिष्टे आहेत. अनेक किल्ले, लेणी, मंदिरे, कबरी, मशिदी, उद्याने, महाल, दरवाजे, सरोवरे, बारव, शिल्पे आणि शिलालेख संचालनालयाने संरक्षित केली आहेत.`,
      paragraph3: `प्राचीन भारतीय वारशाचे जतन करून पुढील पिढ्यांना ते दाखवण्याचे महत्वाचे काम 'वस्तुसंग्रहालये' करतात. संचालनालयाच्या अधिकार क्षेत्रात असलेल्या १३ संग्रहालयातून, विविध उत्खनने आणि शोध कार्यक्रमातून उजेडात आलेल्या कलाकृती, महत्वाच्या ऐतिहासिक व पुरातन वास्तू, वस्तु, शस्त्रे,कपडे आणि पोशाख, शिल्पे आणि कलावस्तू, कलाकृती, शिलालेख, ताम्रपट, प्राचीन-मध्ययुगीन संरचनात्मक अवशेष आणि थोर कलाकारांच्या दुर्मिळ चित्रकृती जतन करण्यात आल्या आहेत. संग्रहालयांचे प्रमुख उद्दिष्ट आहे या वस्तु केवळ लोकरंजनासाठी प्रदर्शित करणे नसून तर त्यांना शिक्षणाचे प्रभावी माध्यम बनवणे, हेही आहे.`,
      paragraph4: `महाराष्ट्र शासनाच्या सांस्कृतिक कार्य विभागाच्या अधीनस्थ असलेले संचालनालय सध्या एक अत्याधुनिक आणि भव्य असे महाराष्ट्र राज्य संग्रहालय उभारण्याच्या प्रक्रियेत आहे. हे संग्रहालय महाराष्ट्राच्या प्राचीन इतिहासापासून आधुनिक कालखंडापर्यंतचा समृद्ध आणि वैविध्यपूर्ण सांस्कृतिक वारसा सादर करण्यासाठी एक महत्त्वाचे केंद्र ठरेल. या संग्रहालयात प्रागैतिहासिक युग, प्राचीन राजवंश, मध्ययुगीन काळातील सामाजिक-सांस्कृतिक घडामोडी, स्वातंत्र्य चळवळ, आणि स्वतंत्र भारतातील महाराष्ट्राचा विकास अशा विविध टप्प्यांचा समावेश करण्यात येईल. प्रेक्षकांना माहितीपूर्ण आणि आकर्षक अनुभव मिळावा यासाठी आधुनिक तंत्रज्ञानाचा वापर, संवादात्मक (interactive) प्रदर्शन व्यवस्था, मल्टिमिडिया माध्यमांचा वापर, तसेच डिजिटल आणि भौतिक वस्तुंचे सादरीकरण यांचा समावेश असेल. हे संग्रहालय फक्त भूतकाळाची ओळख करून देणारेच न राहता, तर संशोधन, शिक्षण आणि नव्या पिढीला प्रेरणा देणारे ज्ञानाचे केंद्र म्हणून कार्य करेल.`,
      paragraph5: `आपल्या राष्ट्राचा गौरवशाली इतिहास आणि वारसा नागरिकांना ज्ञात व्हावा, यासाठी संचालनालय पुस्तकेही प्रकाशित करते. यासहीत संग्रहालय पुस्तिका, संग्रहालयातील संग्रह व प्रदर्शनांचे विवरणिकांसारखी प्रकाशने इत्यादी. संचालनालय  तर्फे 'महाराष्ट्र पुरातत्व' या शीर्षकाखाली वार्षिक अहवाल, वास्तूंच्या जतन, दुरुस्ती, संवर्धनाचे अहवाल, 'ऐतिहासिक स्थलदर्शन माला' ही ऐतिहासिक स्थळांची पुस्तकमालिका आणि उत्खनन अहवाल स्वतंत्र पुस्तकरूपात प्रकाशित केले जातात.`,
      heading1: `ध्येय`,
      heading2: `दृष्टी`,
      heading3: `योजना`,
      heading4: `पुरस्कार`,
      awardstext: "वारसा जतन, संग्रहालय चळवळ व उभारणी या विषयांतील पद्मश्री सदाशिव गोरक्षकर यांचे योगदान मोलाचे आहे.",
      schemesText: "गड किल्ल्यांचे संवर्धन चांगल्या प्रकारे व्हावे व त्यासाठी दुर्गप्रेमी संस्थांचा, व्यक्तींचा आणि दुर्ग तंज्ञाचा सहभाग मिळावा तसेच छत्रपती शिवाजी महाराजांच्या प्रेरणादायी जीवनाची नवीन पिढीला ओळख करुन देण्यासाठी",

    },
  };

  const t = content[selectedLang];

  return (
    <div className="py-12">
      {/* Title Section */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}/{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      {/* Content Section */}
      <div
        className="flex flex-col lg:flex-row items-start gap-8 px-4 lg:px-16 py-6"
        style={{ background: "#F6F6EC" }}
      >
        {/* Left Image Section */}
        <div className="w-full lg:w-1/3">
          <img
            src={img}
            alt="Museum"
            className="w-full h-auto rounded-3xl shadow-lg object-cover"
          />
        </div>

        {/* Right Text Section */}
        <div
          className="w-full lg:w-2/3 text-justify space-y-5 font-futura "
        // style={{
        //   fontFamily: "Futura PT",
        //   fontSize: "16px",
        //   color: "#000000",
        // }}
        >
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            {t.paragraph}
          </p>

          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            {t.paragraph1}
          </p>

          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            {t.paragraph2}
          </p>

          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            {t.paragraph3}
          </p>
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            {t.paragraph4}
          </p>
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            {t?.paragraph5}
          </p>
        </div>
      </div>

      {/* Schemes Section */}
      {/* <div className="px-4 sm:px-6 md:px-12 lg:px-20 pb-16 pt-28 space-y-12">
        <div className="flex flex-col md:flex-row items-center pt-16 gap-6 md:gap-12">
          <img
            src={schemeImg}
            alt="Schemes"
            className="w-full md:w-1/2 rounded-lg max-h-[200px]"
          />
          <div className="text-center md:text-center md:w-1/2">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-semibold mb-5">
              {t.heading3}
            </h2>
            <p className="text-[14px] sm:text-lg md:text-xl lg:text-[16px] leading-relaxed text-gray-800">
              {t.schemesText}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row-reverse items-center pt-16 gap-6 md:gap-12">
          <img
            src={awardsImg2}
            alt="Vision"
            className="w-full md:w-1/2 rounded-lg max-h-[200px]"
          />
          <div className="text-center md:text-center md:w-1/2">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-semibold mb-5">
              {t.heading4}
            </h2>
            <p className="text-[14px] sm:text-lg md:text-xl lg:text-[16px] leading-relaxed text-gray-800">
              {t.awardstext}
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Overview;
